export default "__VITE_ASSET__CSpvqWUH__"